import { IDirectUpload } from "config";

const directUploadApi = {
  uploadFile: async (file: File, directUpload: IDirectUpload) => {
    try {
      const { headers, url } = directUpload;

      const options = {
        headers: JSON.parse(headers),
        method: "PUT",
        body: file,
      };

      await fetch(url, options);
    } catch (error) {
      throw new Error(`Failed to upload file: ${file.name}`);
    }
  },
};

export default directUploadApi;
